<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
        v-if="$route.query.id"
      ></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20 flex" type="flex" :gutter="20" align="middle">
        <span class="text">{{ $t('readUserList.status') }}:</span>
        <el-radio-group size="medium" v-model="filter.status">
          <el-radio label>{{ $t('readUserList.all') }}</el-radio>
          <el-radio :label="0">{{ $t('readUserList.status0') }}</el-radio>
          <el-radio :label="1">{{ $t('readUserList.status1') }}</el-radio>
          <el-radio :label="2">{{ $t('readUserList.status2') }}</el-radio>
          <el-radio :label="3">{{ $t('readUserList.status3') }}</el-radio>
          <el-radio :label="4">{{ $t('readUserList.status4') }}</el-radio>
        </el-radio-group>
      </el-row>
      <el-row class="mt20" type="flex" align="middle">
        <el-button @click="get_list" type="primary" class="search">{{
          $t('search_zh')
        }}</el-button>
        <el-button @click="reset" type="info">{{
          $t('btnTip.reset')
        }}</el-button>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <div>
          <el-button type="primary" @click="dialogAddUserVisible = true"
            >신청자 추가</el-button
          >
        </div>
        <div>
          <el-dropdown class="mr10" @command="multiple_allow_print">
            <el-button type="warning">수료증 일괄 처리 </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="true">발급</el-dropdown-item>
              <el-dropdown-item :command="false">취소</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown class="mr10" @command="multiple_update">
            <el-button type="warning">일괄 승인 </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">신청승인</el-dropdown-item>
              <el-dropdown-item :command="2">신청반려</el-dropdown-item>
              <el-dropdown-item :command="4">환불승인</el-dropdown-item>
              <el-dropdown-item :command="5">환불반려</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="outExe">{{
            $t('outExe')
          }}</el-button>
          <el-button type="primary" @click="outExeAll('read_userList')"
            >전체출력</el-button
          >
        </div>
      </div>
      <my-table
        :columns="columns"
        :data="transformedList"
        :showIndex="false"
        :showSelection="true"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:gender="slotProps">
          <div>{{ gender(slotProps.callback.row.gender) }}</div>
        </template>
        <template v-slot:user_address="slotProps">
          <div>
            {{ slotProps.callback.row.user_address }}
            {{ slotProps.callback.row.address_detail }}
          </div>
        </template>
        <template v-slot:user_address_code="slotProps">
          <div>
            {{ slotProps.callback.row.user_address_code }}
          </div>
        </template>
        <template v-slot:status="slotProps">
          <el-tag :type="statusTag(slotProps.callback.row.status)">{{
            status(slotProps.callback.row.status)
          }}</el-tag>
        </template>
        <template v-slot:club_changbi_list_1="slotProps">
          <div style="white-space: pre-wrap;">
            {{
              slotProps.callback.row.club_changbi
                ? slotProps.callback.row.club_changbi_list_1
                : slotProps.callback.row.club_changbi_list_1[0]
                ? `(${slotProps.callback.row.club_changbi_list_1[0].author}) ${slotProps.callback.row.club_changbi_list_1[0].title}`
                : ''
            }}
          </div>
        </template>
        <template v-slot:club_changbi_list_2="slotProps">
          <div style="white-space: pre-wrap;">
            {{
              slotProps.callback.row.club_changbi
                ? slotProps.callback.row.club_changbi_list_2
                : slotProps.callback.row.club_changbi_list_2[0]
                ? `(${slotProps.callback.row.club_changbi_list_2[0].author}) ${slotProps.callback.row.club_changbi_list_2[0].title}`
                : ''
            }}
          </div>
        </template>
        <template v-slot:club_changbi_list_3="slotProps">
          <div style="white-space: pre-wrap;">
            {{
              slotProps.callback.row.club_changbi
                ? slotProps.callback.row.club_changbi_list_3
                : slotProps.callback.row.club_changbi_list_3[0]
                ? `(${slotProps.callback.row.club_changbi_list_3[0].author}) ${slotProps.callback.row.club_changbi_list_3[0].title}`
                : ''
            }}
          </div>
        </template>
        <template v-slot:club_changbi_list_4="slotProps">
          <div style="white-space: pre-wrap;">
            {{
              slotProps.callback.row.club_changbi
                ? slotProps.callback.row.club_changbi_list_4
                : slotProps.callback.row.club_changbi_list_4[0]
                ? `(${slotProps.callback.row.club_changbi_list_4[0].author}) ${slotProps.callback.row.club_changbi_list_4[0].title}`
                : ''
            }}
          </div>
        </template>
        <template v-slot:club_changbi_list_5="slotProps">
          <div style="white-space: pre-wrap;">
            {{
              slotProps.callback.row.club_changbi
                ? slotProps.callback.row.club_changbi_list_5
                : slotProps.callback.row.club_changbi_list_5[0]
                ? `(${slotProps.callback.row.club_changbi_list_5[0].author}) ${slotProps.callback.row.club_changbi_list_5[0].title}`
                : ''
            }}
          </div>
        </template>
        <template v-slot:order_quantity="slotProps">
          <div>
            {{
              slotProps.callback.row.order_quantity
                ? slotProps.callback.row.order_quantity
                : 1
            }}
          </div>
        </template>
        <!-- <template v-slot:allow_print="slotProps">
          <el-switch
            @change="handleClick('change_print', slotProps.callback.row)"
            v-model="slotProps.callback.row.allow_print"
            active-color="#13ce66"
            inactive-color="#ff4949"
          >
          </el-switch>
        </template> -->
        <template v-slot:operation="slotProps">
          <el-tooltip
            class="item"
            effect="dark"
            content="도서 옵션 변경"
            placement="top"
            v-if="
              slotProps.callback.row.club_type == 0 &&
                !slotProps.callback.row.club_changbi
            "
          >
            <el-button
              @click="handleClick('option', slotProps.callback.row)"
              type="warning"
              size="mini"
              >도서 옵션 변경</el-button
            >
          </el-tooltip>
          <!-- <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').check"
            placement="top"
          >
            <el-button
              @click="handleClick('check', slotProps.callback.row)"
              icon="el-icon-view"
              type="success"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            v-if="slotProps.callback.row.status === 2"
            class="item"
            effect="dark"
            :content="$t('btnTip').edit"
            placement="top"
          >
            <el-button
              @click="handleClick('edit', slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-dropdown
            v-if="
              slotProps.callback.row.status === 0 ||
                slotProps.callback.row.status === 3
            "
            class="ml10 mr10"
            @command="handleCommand"
          >
            <el-button type="warning" size="mini">{{
              $t('readUserList.changeStatus')
            }}</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                :command="{ status: 1, row: slotProps.callback.row }"
                >{{ $t('readUserList.allow') }}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="slotProps.callback.row.status === 0"
                :command="{ status: 2, row: slotProps.callback.row }"
                >{{ $t('readUserList.cancel') }}</el-dropdown-item
              >
              <el-dropdown-item
                v-if="slotProps.callback.row.status === 3"
                :command="{ status: 4, row: slotProps.callback.row }"
                >{{ $t('readUserList.refund') }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t('btnTip').delete }}</el-button
            >
          </el-tooltip> -->
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="500px">
      <form-page
        :ref-obj.sync="formInfo.ref"
        :data="formInfo.data"
        :field-list="formInfo.fieldList"
        :rules="formInfo.rules"
        :label-width="formInfo.labelWidth"
        :list-type-info="listTypeInfo"
        :disabled="formInfo.disabled"
      ></form-page>
      <span slot="footer" class="dialog-footer">
        <el-button @click="done" type="primary" class="ml30">{{
          $t('btnTip.submit')
        }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="사용자 추가"
      :visible.sync="dialogAddUserVisible"
      width="500px"
    >
      <article>
        <div class="flex" style="gap: 4px">
          <div class="disable-input">
            <img src="@/assets/img/excel-color.png" alt="" />
            <p>add_user_club_template.xlsx</p>
          </div>
          <a href="/add_user_club_template.xlsx" download>
            <el-button type="default">다운로드</el-button>
          </a>
        </div>
        <p class="excel-desc">
          반드시 제공하는 엑셀 파일을 이용해 파일을 업로드 하세요.
        </p>
      </article>
      <article>
        <h3 class="form-label">파일 업로드</h3>
        <div class="input-container">
          <el-input
            v-model="excelFormData.name"
            placeholder="파일 형식 (xlsx)"
            readonly
          />
          <input
            ref="fileInput"
            type="file"
            accept=".xlsx,.xls"
            style="display: none"
            @change="handleFileChange"
          />
          <el-button type="default" @click="triggerFileInput"
            >파일 선택</el-button
          >
        </div>
      </article>

      <div class="button-container">
        <el-button type="default" @click="dialogAddUserVisible = false"
          >취소</el-button
        >
        <el-button type="primary" @click="addUserSubmit">등록하기</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="옵션 변경"
      :visible.sync="dialogBookOptionVisible"
      width="500px"
    >
      <div class="option-list">
        <div
          class="select-container"
          v-if="club_info.club_changbi_list_1.length != 0"
        >
          <h3>선택도서 1</h3>
          <el-select
            class="select_what"
            v-model="option_list[0]"
            :placeholder="'단행본 선택 (선택도서 1)'"
          >
            <el-option
              v-for="ele in club_info.club_changbi_list_1"
              :key="ele.id"
              :value="ele.id"
              :label="`${ele.title} / ${ele.author}`"
            >
              <div class="text-body2" style="white-space: normal">
                {{ `${ele.title} / ${ele.author}` }}
              </div>
              <div class="text-caption2 gray400" style="white-space: normal">
                {{ ele.lineCopy }}
              </div>
            </el-option>
          </el-select>
        </div>
        <div
          class="select-container"
          v-if="club_info.club_changbi_list_2.length != 0"
        >
          <h3 class="text-body1">선택도서 2</h3>
          <el-select
            class="select_what"
            v-model="option_list[1]"
            :placeholder="'단행본 선택 (선택도서 2)'"
          >
            <el-option
              v-for="ele in club_info.club_changbi_list_2"
              :key="ele.id"
              :value="ele.id"
              :label="`${ele.title} / ${ele.author}`"
            >
              <div class="text-body2" style="white-space: normal">
                {{ `${ele.title} / ${ele.author}` }}
              </div>
              <div class="text-caption2 gray400" style="white-space: normal">
                {{ ele.lineCopy }}
              </div>
            </el-option>
          </el-select>
        </div>
        <div
          class="select-container"
          v-if="club_info.club_changbi_list_3.length != 0"
        >
          <h3 class="text-body1">선택도서 3</h3>
          <el-select
            class="select_what"
            v-model="option_list[2]"
            :placeholder="'단행본 선택 (선택도서 3)'"
          >
            <el-option
              v-for="ele in club_info.club_changbi_list_3"
              :key="ele.id"
              :value="ele.id"
              :label="`${ele.title} / ${ele.author}`"
            >
              <div class="text-body2" style="white-space: normal">
                {{ `${ele.title} / ${ele.author}` }}
              </div>
              <div class="text-caption2 gray400" style="white-space: normal">
                {{ ele.lineCopy }}
              </div>
            </el-option>
          </el-select>
        </div>
        <div
          class="select-container"
          v-if="club_info.club_changbi_list_4.length != 0"
        >
          <h3 class="text-body1">선택도서 4</h3>
          <el-select
            class="select_what"
            v-model="option_list[3]"
            :placeholder="'단행본 선택 (선택도서 4)'"
          >
            <el-option
              v-for="ele in club_info.club_changbi_list_4"
              :key="ele.id"
              :value="ele.id"
              :label="`${ele.title} / ${ele.author}`"
            >
              <div class="text-body2" style="white-space: normal">
                {{ `${ele.title} / ${ele.author}` }}
              </div>
              <div class="text-caption2 gray400" style="white-space: normal">
                {{ ele.lineCopy }}
              </div>
            </el-option>
          </el-select>
        </div>
        <div
          class="select-container"
          v-if="club_info.club_changbi_list_5.length != 0"
        >
          <h3 class="text-body1">선택도서 5</h3>
          <el-select
            class="select_what"
            v-model="option_list[4]"
            :placeholder="'단행본 선택 (선택도서 5)'"
          >
            <el-option
              v-for="ele in club_info.club_changbi_list_5"
              :key="ele.id"
              :value="ele.id"
              :label="`${ele.title} / ${ele.author}`"
            >
              <div class="text-body2" style="white-space: normal">
                {{ `${ele.title} / ${ele.author}` }}
              </div>
              <div class="text-caption2 gray400" style="white-space: normal">
                {{ ele.lineCopy }}
              </div>
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="button-container">
        <el-button type="default" @click="dialogBookOptionVisible = false"
          >취소</el-button
        >
        <el-button type="primary" @click="handleChangeOption"
          >변경하기</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mixin_list } from '@/mixins';
import page from '@/components/page';
import FormPage from '@/components/FormPage';
import myTable from '@/components/table';
import {
  readUserList,
  deleteReadUser,
  editReadUser,
  multiple_update_read_userList,
  readUserPrint,
  readDetail,
  update_club_changbi,
  add_user_club,
} from '@/api/api';
const formInfoData = {
  refuse_reason: '',
};
export default {
  name: 'readUserList',
  mixins: [mixin_list(readUserList)],
  components: {
    myTable,
    FormPage,
    page,
  },
  data() {
    return {
      filter: {
        search: '',
        status: '',
        club: this.$route.query.id,
      },
      columns: [
        {
          label: 'ID',
          sortable: true,
          prop: 'id',
          width: 80,
        },
        {
          label: this.$t('readUserList.create_time'),
          sortable: true,
          prop: 'create_time',
        },
        {
          label: this.$t('readUserList.username'),
          sortable: true,
          prop: 'username',
        },
        {
          label: this.$t('readUserList.real_name'),
          sortable: true,
          prop: 'real_name',
          width: 120,
        },
        {
          label: this.$t('readUserList.age'),
          sortable: true,
          prop: 'age',
          width: 120,
        },
        {
          label: this.$t('readUserList.gender'),
          sortable: true,
          prop: 'gender',
          width: 80,
          slot: 'gender',
        },
        {
          label: this.$t('readUserList.phone_num'),
          sortable: true,
          prop: 'phone_num',
        },
        {
          label: this.$t('readUserList.user_address'),
          sortable: true,
          prop: 'user_address',
          slot: 'user_address',
        },
        {
          label: this.$t('readUserList.user_address_code'),
          sortable: true,
          prop: 'user_address_code',
          slot: 'user_address_code',
        },
        {
          label: this.$t('readUserList.delivery_request'),
          sortable: true,
          prop: 'delivery_request',
        },
        {
          label: this.$t('readUserList.club_title'),
          sortable: true,
          prop: 'club_title',
        },
        {
          label: this.$t('readUserList.order_pay_amount'),
          sortable: true,
          prop: 'order_pay_amount',
        },
        {
          label: this.$t('readUserList.coupon_title'),
          sortable: false,
          prop: 'coupon_title',
        },
        {
          label: this.$t('readUserList.count'),
          sortable: false,
          prop: 'order_quantity',
          slot: 'order_quantity',
        },
        {
          label: this.$t('readUserList.book_option_1'),
          sortable: true,
          prop: 'club_changbi_list_1',
          slot: 'club_changbi_list_1',
        },
        {
          label: this.$t('readUserList.book_option_2'),
          sortable: true,
          prop: 'club_changbi_list_2',
          slot: 'club_changbi_list_2',
        },
        {
          label: this.$t('readUserList.book_option_3'),
          sortable: true,
          prop: 'club_changbi_list_3',
          slot: 'club_changbi_list_3',
        },
        {
          label: this.$t('readUserList.book_option_4'),
          sortable: true,
          prop: 'club_changbi_list_4',
          slot: 'club_changbi_list_4',
        },
        {
          label: this.$t('readUserList.book_option_5'),
          sortable: true,
          prop: 'club_changbi_list_5',
          slot: 'club_changbi_list_5',
        },
        {
          label: this.$t('readUserList.refuse_reason'),
          sortable: true,
          prop: 'refuse_reason',
        },
        {
          label: this.$t('readUserList.status'),
          sortable: true,
          prop: 'status',
          slot: 'status',
          width: 100,
        },
        {
          label: this.$t('readUserList.allow_print'),
          sortable: true,
          prop: 'allow_print',
          slot: 'allow_print',
          width: 120,
        },
        // {
        //   label: this.$t('readUserList.group_leader'),
        //   sortable: true,
        //   prop: 'group_leader',
        // },
        {
          label: this.$t('operation'),
          prop: '',
          width: 120,
          slot: 'operation',
          fixed: 'right',
        },
      ],
      formInfo: {
        ref: null,
        disabled: false,
        data: formInfoData,
        fieldList: [
          {
            label: this.$t('readUserList').refuse_reason,
            value: 'refuse_reason',
            width: '260',
            type: 'textarea',
            className: 'el-form-block',
            required: false,
            hidden: false,
            showlimit: true,
            maxlength: 30,
          },
        ],
        rules: {},
        labelWidth: '120px',
      },
      listTypeInfo: {},
      dialogFormVisible: false,
      dialogAddUserVisible: false,
      dialogBookOptionVisible: false,
      which: '',
      excelFormData: { name: '' },
      // 옵션 변경 관련 변수
      club_info: {
        club_changbi_list_1: [],
        club_changbi_list_2: [],
        club_changbi_list_3: [],
        club_changbi_list_4: [],
        club_changbi_list_5: [],
      },
      option_list: [],
      option_info: {
        order_id: 0,
        club_changbi_1: null,
        club_changbi_2: null,
        club_changbi_3: null,
        club_changbi_4: null,
        club_changbi_5: null,
      },
    };
  },
  computed: {
    title() {
      switch (this.which) {
        case 'add':
          return this.$t('btnTip').add;
        case 'edit':
          return this.$t('btnTip').edit;
      }
    },
    transformedList() {
      // 원본 list_data.list를 변환
      return this.list_data.list.map((item) => {
        if (item.club_changbi) {
          const newItem = { ...item }; // 원본 데이터 복사

          // 기본적으로 club_changbi_list_1 ~ club_changbi_list_5를 빈 문자열로 초기화
          for (let i = 1; i <= 5; i++) {
            newItem[`club_changbi_list_${i}`] = ''; // 초기값 설정
          }

          // club_changbi를 \r\n 기준으로 나누기
          if (item.club_changbi) {
            const lines = item.club_changbi.split('\n'); // 줄바꿈 기준으로 분리

            lines.forEach((line) => {
              const match = line.match(/\(선택도서 (\d+), [^)]+\) .+/); // 정규식으로 선택도서 추출
              if (match) {
                const [, bookNumber] = match; // 선택도서 번호 추출
                const bookIndex = parseInt(bookNumber, 10); // 번호를 숫자로 변환
                if (bookIndex >= 1 && bookIndex <= 5) {
                  // 1~5 범위만 처리
                  newItem[`club_changbi_list_${bookIndex}`] = line; // 원본 문자열 저장
                }
              }
            });
          }

          return newItem; // 변환된 객체 반환
        } else {
          return item;
        }
      });
    },
  },
  methods: {
    async handleCommand(command) {
      if (command.status === 2) {
        this.handleClick('edit', command.row, command.status);
        return;
      }
      await multiple_update_read_userList({
        status: command.status,
        update_id: command.row.id + '',
      });
      this.get_list();
    },
    gender(gender) {
      switch (gender) {
        case '0':
          return this.$t('readUserList.gender0');
        case '1':
          return this.$t('readUserList.gender1');
        case '2':
          return this.$t('readUserList.gender2');
      }
    },
    statusTag(statusTag) {
      switch (statusTag) {
        case 0:
          return 'primary';
        case 1:
          return 'success';
        case 2:
          return 'info';
        case 3:
          return 'warning';
        case 4:
          return 'danger';
      }
    },
    status(status) {
      switch (status) {
        case 0:
          return this.$t('readUserList.status0');
        case 1:
          return this.$t('readUserList.status1');
        case 2:
          return this.$t('readUserList.status2');
        case 3:
          return this.$t('readUserList.status3');
        case 4:
          return this.$t('readUserList.status4');
      }
    },

    handleChangeOption() {
      if (this.checkSelectOption()) {
        const body = {
          order_id: this.order_id,
          club_changbi_1: this.option_list[0],
          club_changbi_2: this.option_list[1],
          club_changbi_3: this.option_list[2],
          club_changbi_4: this.option_list[3],
          club_changbi_5: this.option_list[4],
        };

        update_club_changbi(this.club_info.id, body)
          .then(() => {
            this.$message.success('옵션이 변경되었습니다.');
            this.dialogBookOptionVisible = false;
            this.$router.go(this.$router.currentRoute);
          })
          .catch(() => {
            this.$message.error('옵션 변경에 실패했습니다.');
          });
      }
    },

    // 옵션 체크
    checkSelectOption() {
      // 도서 리스트가 있는데 선택하지 않았을 경우 false
      if (
        this.club_info.club_changbi_list_1.length != 0 &&
        !this.option_list[0]
      ) {
        return false;
      }
      if (
        this.club_info.club_changbi_list_2.length != 0 &&
        !this.option_list[1]
      ) {
        return false;
      }
      if (
        this.club_info.club_changbi_list_3.length != 0 &&
        !this.option_list[2]
      ) {
        return false;
      }
      if (
        this.club_info.club_changbi_list_4.length != 0 &&
        !this.option_list[3]
      ) {
        return false;
      }
      if (
        this.club_info.club_changbi_list_5.length != 0 &&
        !this.option_list[4]
      ) {
        return false;
      }

      return true;
    },
    async handleClick(type, data, status) {
      switch (type) {
        case 'edit':
          if (status === 2) {
            this.formInfo.data = { ...data, status };
          } else {
            this.formInfo.data = { ...data };
          }
          this.initRules();
          this.formInfo.disabled = type !== 'check' ? false : true;
          this.dialogFormVisible = true;
          this.which = type;
          break;
        case 'change_print':
          await readUserPrint({
            print_id: '' + data.id,
            status: data.allow_print,
          });
          this.get_list();
          break;
        case 'option':
          this.club_info = await readDetail(data.club);
          this.order_id = data.order_id;
          this.option_list[0] = data.club_changbi_list_1[0]?.id || null;
          this.option_list[1] = data.club_changbi_list_2[0]?.id || null;
          this.option_list[2] = data.club_changbi_list_3[0]?.id || null;
          this.option_list[3] = data.club_changbi_list_4[0]?.id || null;
          this.option_list[4] = data.club_changbi_list_5[0]?.id || null;
          this.dialogBookOptionVisible = true;
          break;
      }
    },
    done() {
      switch (this.which) {
        case 'edit':
          this.formInfo.ref.validate(async (valid) => {
            if (valid) {
              await editReadUser(this.formInfo.data);
              this.get_list();
            }
          });
          break;
      }
      this.dialogFormVisible = false;
    },
    async del(id) {
      this.$confirm(
        this.$t('readUserList').sureDeleteReadUser,
        this.$t('tips'),
        {
          confirmButtonText: this.$t('btnTips').submit,
          cancelButtonText: this.$t('btnTips').cancel,
          type: 'warning',
        }
      )
        .then(async () => {
          let res = await deleteReadUser(id);
          this.get_list();
        })
        .catch({});
    },
    async multiple_allow_print(command) {
      if (this.selete.length === 0) {
        this.$message({
          message: '처리하시려는 옵션을 선택해 주세요.',
          type: 'warning',
        });
      } else {
        await readUserPrint({
          status: command,
          print_id: this.selete
            .map((item) => {
              return item.id;
            })
            .join(','),
        });
        this.get_list();
      }
    },
    async multiple_update(command) {
      if (this.selete.length === 0) {
        this.$message({
          message: '처리하시려는 옵션을 선택해 주세요.',
          type: 'warning',
        });
      } else {
        await multiple_update_read_userList({
          status: command,
          update_id: this.selete
            .map((item) => {
              return item.id;
            })
            .join(','),
        });
        this.get_list();
      }
    },
    addUserSubmit() {
      // 파일을 읽거나 API로 전송
      const formData = new FormData();
      formData.append('file', this.excelFormData);

      add_user_club(formData)
        .then(() => {
          window.location.reload();
        })
        .catch((e) => console.log(e));
    },
    triggerFileInput() {
      const fileInput = this.$refs.fileInput; // 숨겨진 input 참조
      if (fileInput) {
        fileInput.click(); // 파일 입력창 트리거
      }
    },
    handleFileChange(event) {
      const input = event.target;
      if (input.files && input.files.length > 0) {
        this.excelFormData = input.files[0];

        // 파일 크기 및 유형 확인
        if (
          this.excelFormData.type !==
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          this.excelFormData.type !== 'application/vnd.ms-excel'
        ) {
          alert('올바른 Excel 파일을 선택하세요.');
          return;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  width: 100px;
  font-size: 16px;
}
/deep/ label {
  margin-bottom: 0 !important;
}
/deep/.el-dialog__header {
  text-align: center;
}
/deep/.el-dialog__title {
  font-family: 'Pretendard-Semibold';
  font-size: 16px;
  color: black;
}
.button-container {
  display: flex;
  margin-top: 40px;

  button {
    width: 100%;
    height: 50px;
  }
}
.form-label {
  font-family: 'Pretendard-Semibold';
  font-size: 16px;
  color: black;
  margin-bottom: 8px;
}
.input-container {
  display: flex;
  gap: 4px;

  .el-input {
    width: 100%;
  }

  /deep/.el-upload-list {
    display: none;
  }
}

.disable-input {
  display: flex;
  align-items: center;
  padding: 0 12px;
  width: 100%;
  height: 40px;
  gap: 8px;
  border: 1px solid #acb0b3;
  background-color: #f5f5f5;
  border-radius: 4px;

  img {
    width: 24px;
    height: 24px;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    color: black;
  }
}

.excel-desc {
  font-size: 14px;
  margin-top: 4px;
  margin-bottom: 12px;
}

.option-list {
  .select-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    h3 {
      font-size: 14px;
      line-height: 22px;
      color: black;
    }
  }

  .select_what {
    position: relative;
    color: black;
    white-space: nowrap;
    width: 100%;

    /deep/.el-select-dropdown {
      position: absolute !important;
      left: auto !important;
    }
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  /deep/.el-input.is-focus {
    .el-input__inner {
      border: 1px solid black;
    }
  }
  /deep/.el-input__inner {
    // .text-body2;

    height: 50px;
    border: 1px solid #acb0b3;
    padding: 14px 12px;
    // border: 1px solid #000000 !important;
    // padding: 0 0.75rem !important;
    // box-sizing: border-box !important;
    // height: 2rem;
    // width: 7.5rem;
  }

  /deep/.el-input__suffix {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    // top: -3px;
    // right: 10px;
    .el-input__suffix-inner {
      height: 21px;
    }
  }
  /deep/.el-input__icon {
    height: 21px;
    line-height: 21px;
  }
}
</style>
<style lang="scss">
.el-select-dropdown {
  .el-select-dropdown__item.selected {
    font-weight: 500;
  }
  .el-select-dropdown__item {
    height: auto !important;
  }
}
</style>
